import React, { useEffect } from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import STRINGS from './constants';

const FooterLinks = (props) => {
	const { siteDetails } = props;
	useEffect(() => {
		const fidesCode = document.getElementById('fides-code');
		if (fidesCode) {
			fidesCode.addEventListener('load', () => {
				if (window.Fides) {
					document.getElementById('fides-modal-link').innerText = window.Fides.getModalLinkLabel();
				}
			});
		}
	}, []);
	return (
		<Box
			className='sma-automation-copyright'
			style={{
				maxWidth: 400,
				alignContent: 'center',
				margin: 'auto',
				padding: '10px 0',
			}}
		>
			<Typography align='center'>
				{STRINGS.copyright} &copy; {STRINGS.surveyMonkey}
				{' | '}
				<a href={reverse('help-center')} target='_blank' rel='noreferrer'>{STRINGS.help}</a>
				{' | '}
				<a href={reverse('privacy-url')} target='_blank' rel='noreferrer'>{STRINGS.privacy}</a>
				{' | '}
				<a href={reverse('tos-url')} target='_blank' rel='noreferrer'>{STRINGS.terms}</a>
			</Typography>
			{siteDetails.useFides && (
				<Typography
					component='a'
					className='fides-modal-link-show'
					id='fides-modal-link'
					onClick={(e) => {
						e.preventDefault();
						if (window.Fides) window.Fides.showModal();
					}}
					style={{ textWrap: 'nowrap', textAlign: 'center', display: 'block' }}
				>
					{window?.Fides?.getModalLinkLabel()}
				</Typography>
			)}
		</Box>
	);
};

export default FooterLinks;
